export const gatewayDepositThemeColors = {
  primary: '#FF0095',
  secondary: '#F7F63F',
  tertiary: '#FF0095',
  h1: '#000',
  success: '#96DF7A',
  info: '#3BCFD5',
  warning: '#F3B258',
  danger: '#DD3570',
  dark: '#1E1E1E',
  activeColor: '#FFFFFF',
  contrastActiveColor: '#000000',
  loaderFirst: '#FF0095',
  loaderSecond: '#F7F63F',
  loaderThird: '#FF0095',
  borderColor: '#FF0095',
  roundedGrey: '#7ee16b',
};